import { render, staticRenderFns } from "./sub_title_component.vue?vue&type=template&id=2159dd8d&"
import script from "./sub_title_component.vue?vue&type=script&lang=js&"
export * from "./sub_title_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports